import { observer } from 'mobx-react-lite';
import { EditPage } from 'src/components/FormPages/EditPage';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { SettingsNotificationTemplatesStore } from 'src/stores/SettingsStores/SettingsNotificationTemplatesStore/SettingsNotificationTemplatesStore';

export const NotificationTemplateEdit = observer(() => {
    return (
        <EditPage
            pageName="setting-notification-templates"
            store={SettingsNotificationTemplatesStore}
            baseUrl={RoutePaths.settingsNotificationTemplates}
        />
    );
});
